import React from 'react';
import WorkExperience from '../components/WorkExperience';

const WorkExperiencePage = () => {
    return (
        <WorkExperience />
    );
};

export default WorkExperiencePage;